<template>
	<el-menu :default-active="currentRoute"
	         mode="horizontal"
	         router>
		<el-menu-item index="/moderator">Dashboard</el-menu-item>
		<el-menu-item index="/moderator/submissions">Reported Submissions</el-menu-item>
		<el-menu-item index="/moderator/comments">Reported Comments</el-menu-item>
	</el-menu>
</template>

<script>
	export default {
		name: "PanelHeader",

		computed: {
			currentRoute() {
				return this.$route.path
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/moderators/comps/Header.vue